const initialState = null;

const editorLanguageReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_EDITOR_LANGUAGE': return action.payload;
        default: return state;
    }
};

export default editorLanguageReducer;
